(function () {
  const currentSection = document.currentScript.parentElement;
  const initHeroContentAnimation = (section) => {
    const animatedSection = section.querySelector(
      '[data-animation-ready="false"]'
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            const heading = section.querySelector(
              ".hero-heading.animated-text"
            );
            if (heading) {
              const words = heading.querySelectorAll(".word");
              heading.style.setProperty("--word-count", words.length);
              section.style.setProperty("--word-count", words.length);
            }
            section.dataset.animationReady = "true";
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    if (animatedSection) {
      observer.observe(animatedSection);
    }
  };
  initHeroContentAnimation(currentSection);
  document.addEventListener("shopify:section:load", (e) => {
    initHeroContentAnimation(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    initHeroContentAnimation(e.target);
  });
})();
